export enum EFoldersSection {
  matricesList = 'matricesList',
  orderList = 'orderList',
  referencesList = 'referencesList',
}
